<template>
  <div>
    <div class="is-warning">

    </div>
    <vue-snotify></vue-snotify>
    <!-- <app-menu :userDatos="userDatos"></app-menu> -->
    <div class="columns">
      <!-- <div :class=" (this.$store.state.showMenu)?'column is-2':'' " v-if="this.$cookies.get('RhSession')"> -->
        <Menu v-if="this.$cookies.get('RhSession')" style="position: fixed; z-index: 999; overflow-y: scroll;" />
      <!-- </div> -->

      <!-- <div class="column">
        test
        <router-view></router-view>
        test end
      </div> -->

    </div>
    <component id="principalContenedor" :is="compon"></component>
    
    <!--  <app-footer></app-footer> -->

  </div>
</template>

<script>
import Login from './components/Login.vue'
import exodus from './components/exodus.vue'
import Manu from './components/menu.vue'
import Menu from './components/menu.vue'

import { EventBus } from './components/bus.js'

// var dateF = moment(new Date()).add(1, 'days').format('MMMM YYYY/MM-DD-YY')// fecha january 2018/01-23-18

export default {
  components: {
    'app-login': Login,
    'app-exodus': exodus,

    // 'app-menu': Manu, Menu // Activate to duplicate Menu app
    'app-menu':Menu
  },
  name: 'app',
  data () {
    return {
      mail: '',
      pass: '',
      compon: 'exodus'
    }
  },

  beforeMount: function () {
    if (!this.$cookies.get('RhSession')) {
      console.log('BC APP cookie no existe')
      this.compon = 'app-exodus'
    } else {
      console.log('BC APP cookie si existe')
      this.compon = 'app-menu'
    }
  },

  created () {
    console.log('se crea app')

    EventBus.$on('passUser', (data) => {
      console.log('se escucha bus')
      if (data === 1) {
        this.compon = 'app-menu'
      } else {
        console.log(' no se cambia ')
      }
    })
  },
  methods: {
    login2: function () {
      console.log('cerramos la sesion ')

      this.$cookies.remove('RhSession')
    }
  }
}
</script>


<style scoped>
  .borderStyle {
  border-style: solid;
  border-color: #245b8c;
  border-width: 3px!important;
}
td {
  padding: 1px!important;
  }
</style>
<style>

.div{
  padding-top:0px;
  padding-bottom:0px;
  text-align: center;
},
.e1 {
  background-color: #D6FFE6;
}
.e2 {
  background-color: #FFDEDB;
}
.e3 {
  background-color: #AEE2F9;
}
.e4 {
  background-color: #A4A4A5;
}
.e5 {
  background-color: #FFE2FE;
}
.e6 {
  background-color: #F9F9F9;
}
.arrow-up {
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #4c7ca5;
  margin-left:2.5rem;
}
.td:hover {
  background-color: #7aabd6;
}
.tooltip {
  display: block !important;
  z-index: 10000;
  }
.tooltip {
  display: block !important;
  z-index: 10000;
  }
  .tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
  }
  .tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  }
  .tooltip[x-placement^="bottom"] {
  margin-top: 5px;
  }
  .tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
  }
  .tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
  }
  .tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
  }
  table th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fff;
    border: 1;
  }
</style>